<template>
    <component
        :is="`${tab}View`"
        :tabSelected="tab"
        :defaultDate="date"
        :scrollToHour="scrollToHour"
        :defaultSelectedPost="defaultSelectedPost"
        :autoValidatePostSelected="validate_post === 'true' || validate_post === true"
        :autoEditPostSelected="edit_post === 'true' || edit_post === true"
        @changeTab="changeTab"
    />
</template>

<script>
    import { EventBus } from '@/event-bus';
    import { clarityEvent } from '@/utils/clarity';
    import store from '@/store/index';
    import ListView from '@/components/dash/posts/List.vue'
    import PlannerView from '@/components/dash/posts/Planner.vue'
    import FeedView from '@/components/dash/posts/Feed.vue'
    import ModalSwitchVersion from '@/components/dash/posts/components/ModalSwitchVersion.vue'
    import postMixins from '@/components/mixins/Posts.vue'
    import draftMixins from '@/components/mixins/Drafts.vue'

    export default {
        mixins: [postMixins, draftMixins],
        components: {
            ListView,
            PlannerView,
            FeedView,
            ModalSwitchVersion
        },
        props: {
            date: {
                type: String,
                default: null
            },
            scrollToHour: {
                type: Boolean,
                default: false
            },
            //Lien profond
            post_id: {
                type: String,
                default: null
            },
            page_id: {
                type: String,
                default: null
            },
            bot_id: {
                type: String,
                default: null
            },
            is_draft: {
                type: Boolean,
                default: false
            },
            edit_post : {
                type: String,
                default: null,
            },
            validate_post: {
                type: String,
                default: null,
            }
        },
        data() {
            return {
                tab: localStorage.getItem('posts/tab') || 'planner',
                defaultSelectedPost: null,
                lastDefaultSelectedPostId: null,
            }
        },

        mounted () {
            EventBus.$emit('selectPageSection/freezeSelectPage', false);
            clarityEvent(`posts_tab:${this.tab}`)
        },
        methods: {
            changeTab(tabName) {
                if (!['list', 'planner','feed'].includes(tabName)) return
                this.tab = tabName
                localStorage.setItem('posts/tab', tabName)
                clarityEvent(`posts_tab:${tabName}`)
               
                
               
            },
            async setupDefaultSelectedPost(){
                console.log("setupDefaultSelectedPost",!this.post_id || !this.page_id || !this.bot_id || !this.pagesLoaded || !this.currentUser)
                console.log("setupDefaultSelectedPost",this.post_id,  this.page_id,  this.bot_id, this.pagesLoaded, this.currentUser)
                if (!this.post_id || !this.page_id || !this.bot_id || !this.pagesLoaded || !this.currentUser) return
                if (this.lastDefaultSelectedPostId === this.post_id) return

                this.lastDefaultSelectedPostId = this.post_id
          
                let res = null
                if (this.is_draft === true || this.is_draft === 'true') {
                    const isMongoDbDraft = /^[0-9a-f]{24}$/i.test(this.post_id || '')
                    if (isMongoDbDraft) {
                        res = await this.findPost(this.bot_id, this.post_id, null)
                    } else {
                        res = await this.findDraft(this.bot_id, this.post_id)
                    }
                }else {
                    res = await this.getPost(this.bot_id, this.post_id)
                }
                    
                if(res && res.body && res.body.post){
                    this.tab = 'planner',
                    this.defaultSelectedPost = res.body.post
                    // Publication automatique (bot d'une source) : pas de scheduled_date, le planner se place sur sa date de publication
                    const embed = res.body.post.page && res.body.post.page[0]
                    this.date = res.body.post.scheduled_date || (embed && (embed.scheduled_date || embed.posted_date)) || res.body.post.published_at
                }
            }
        },

        computed: {
            pagesLoaded() {
                return this.$store.getters['selectPage/isInit'];
            },
            currentUser() {
                return this.$store.getters['users/getCurrentUser']
            },
        },
        watch: {
            pagesLoaded: {
                immediate: true,
                handler() {
                    this.setupDefaultSelectedPost();
                },
            },
            currentUser: {
                immediate: true,
                handler() {
                    this.setupDefaultSelectedPost();
                },
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>